import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../Layout/Header";
import SideBar from "../Layout/SideBar";
import Skeleton from "react-loading-skeleton";
import ReactQuill from "react-quill"; // Importing ReactQuill
import 'react-quill/dist/quill.snow.css'; // Import the CSS for the editor
import { baseURL } from "../../axios/common";

const PolicyManager = () => {
  const [policyContent, setPolicyContent] = useState(""); 
  const [policyType, setPolicyType] = useState(1); // Default to TERMS
  const [loading, setLoading] = useState(true); // Loading state to handle skeleton loader

  useEffect(() => {
    fetchPolicy();
  }, [policyType]);

  const fetchPolicy = async () => {
    try {
      const response = await axios.get(baseURL + `users/getPolicy?type=${policyType}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setPolicyContent(response.data.data || ""); 
      setLoading(false); 
    } catch (error) {
      console.error("Error fetching policy:", error);
      setLoading(false); 
    }
  };

  const handlePolicyTypeToggle = (type) => {
    if (policyType !== type) {
      setPolicyType(type);
      setLoading(true); 
    }
  };

  const handleSavePolicy = async () => {
    try {
      const response = await axios.post(
        baseURL + "admin/upsertPolicy",
        { type: policyType, content: policyContent },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      alert(response.data.message); 
    } catch (error) {
      console.error("Error saving policy:", error);
      alert("Error saving policy!");
    }
  };

  return (
    <div>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid"></div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h2 className="card-title">Manage Policies</h2>
                    </div>
                    <div className="card-body">
                      <div className="d-flex mb-3" style={{ gap: '10px' }}>
                        {loading ? (
                          <>
                            <Skeleton width={100} height={40} />
                            <Skeleton width={100} height={40} />
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => handlePolicyTypeToggle(1)}
                              className={policyType === 1 ? "btn btn-primary" : "btn btn-secondary"}
                            >
                              Terms
                            </button>
                            <button
                              onClick={() => handlePolicyTypeToggle(2)}
                              className={policyType === 2 ? "btn btn-primary" : "btn btn-secondary"}
                            >
                              Policy
                            </button>
                          </>
                        )}
                      </div>
                      <div>
                        {loading ? (
                          <Skeleton height={400} />
                        ) : (
                          <ReactQuill
                            value={policyContent}
                            onChange={setPolicyContent} 
                            modules={quillModules} 
                            theme="snow"
                          />
                        )}
                      </div>
                      <div className="d-flex justify-content-end" style={{ marginTop: '10px' }}>
                        {loading ? (
                          <Skeleton width={100} height={40} />
                        ) : (
                          <button
                            onClick={handleSavePolicy}
                            className="btn btn-primary"
                            style={{ marginTop: '10px', width: 'auto' }}
                          >
                            Submit
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

// Define Quill modules for custom formatting options (bold, italics, bullet points)
const quillModules = {
  toolbar: [
    [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'align': [] }],
    ['bold', 'italic', 'underline'],
    ['link'],
    ['blockquote'],
    [{ 'script': 'sub'}, { 'script': 'super' }],
    [{ 'indent': '-1'}, { 'indent': '+1' }],
    [{ 'direction': 'rtl' }],
    ['clean'] // Clear formatting
  ],
};

export default PolicyManager;
